export default "__VITE_ASSET__CL2k$Atc__"